import projectIcon from "../../../../../public/assets/images/op/projectIcon.svg";
import salonIcon from "../../../../../public/assets/images/op/salonIcon.svg";
import cartIcon from "../../../../../public/assets/images/op/cartIcon.svg";
import cartIconDisabled from "../../../../../public/assets/images/op/cartIcon-disabled.svg";
import domain from "../../../../../public/assets/images/domain.svg";
import volunteerActivism from "../../../../../public/assets/images/volunteerActivism.svg";
export const organizationOnePageCards = (
  data,
  salonDisable,
  projectDisable
) => [
  {
    id: 1,
    name: "پروژه های نیکوکاری ",
    image: projectDisable ? volunteerActivism : projectIcon,
    url: `/crowdfunding?orgName=${data.name}`,
    disabled: projectDisable,
  },
  {
    id: 2,
    name: "رزرو سالن موسسه",
    image: salonDisable ? domain : salonIcon,
    url: `/hall-reservation?orgName=${data.name}`,
    disabled: salonDisable,
  },
  {
    id: 3,
    name: "کارت نیکوکاری",
    image: !data.has_wallet ? cartIconDisabled : cartIcon,
    url: `/gift-cards/${data.slug}`,
    disabled: !data.has_wallet
  },
];
